// import * as React from "react";
// import Box from "@mui/material/Box";
// import Skeleton  from "@mui/material/Skeleton";

// export default function AnimationSkeleton() {
//   return (
//     <Box sx={{ width: 300 }}>
//       <Skeleton />
//       <Skeleton animation="wave" />
//       <Skeleton animation={false} />
//     </Box>
//   );
// }

import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { Grid } from "@mui/material";

export default function AnimationSkeleton() {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <Grid container spacing={3}>
        <Grid item lg={5} md={5} sm={5} xs={5}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={130}
            height={20}
            sx={{ marginRight: 1, marginTop: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={130}
            height={20}
            sx={{ marginRight: 1, marginTop: 1 }}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={2}>
          <Skeleton
            animation="wave"
            variant="circular"
            width={15}
            height={15}
            sx={{ marginRight: 1, marginTop: 2 }}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={10}
            height={50}
            sx={{ marginRight: 1, marginTop: 2, marginLeft: "3px" }}
          />
        </Grid>
        <Grid item lg={5} md={5} sm={5} xs={5}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={150}
            height={50}
            sx={{ marginLeft: -4, marginTop: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={150}
            height={20}
            sx={{ marginTop: 1, marginLeft: -4 }}
          />
        </Grid>

        {/* =========================================== */}
        <Grid item lg={5} md={5} sm={5} xs={5}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={130}
            height={20}
            sx={{ marginRight: 1, marginTop: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={130}
            height={20}
            sx={{ marginRight: 1, marginTop: 1 }}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={2}>
          <Skeleton
            animation="wave"
            variant="circular"
            width={15}
            height={15}
            sx={{ marginRight: 1, marginTop: 2 }}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={10}
            height={50}
            sx={{ marginRight: 1, marginTop: 2, marginLeft: "3px" }}
          />
        </Grid>
        <Grid item lg={5} md={5} sm={5} xs={5}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={150}
            height={50}
            sx={{ marginLeft: -4, marginTop: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={150}
            height={20}
            sx={{ marginTop: 1, marginLeft: -4 }}
          />
        </Grid>

        {/* ------------------------------------------ */}
        <Grid item lg={5} md={5} sm={5} xs={5}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={130}
            height={20}
            sx={{ marginRight: 1, marginTop: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={130}
            height={20}
            sx={{ marginRight: 1, marginTop: 1 }}
          />
        </Grid>
        <Grid item lg={2} md={2} sm={2} xs={2}>
          <Skeleton
            animation="wave"
            variant="circular"
            width={15}
            height={15}
            sx={{ marginRight: 1, marginTop: 2 }}
          />
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={10}
            height={50}
            sx={{ marginRight: 1, marginTop: 2, marginLeft: "3px" }}
          />
        </Grid>
        <Grid item lg={5} md={5} sm={5} xs={5}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width={150}
            height={50}
            sx={{ marginLeft: -4, marginTop: 2 }}
          />

          <Skeleton
            animation="wave"
            variant="rectangular"
            width={150}
            height={20}
            sx={{ marginTop: 1, marginLeft: -4 }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
